import { EListingModalActionType, EListingModalMode, IToggleListingModalPayload } from './types';
import { TThunkAction } from '../../types/redux';
import { actionGenerator } from '../../utils/redux/actionGenerator';

const HISTORY_ENTRY_NAME = 'ListingModal';

export const toggleModalAction = actionGenerator<EListingModalActionType.Toggle, IToggleListingModalPayload>(
  EListingModalActionType.Toggle,
);

let lastPopStateHandler: (evt: PopStateEvent) => void;

export const toggleModal =
  (payload: IToggleListingModalPayload): TThunkAction =>
  async dispatch => {
    dispatch(toggleModalAction(payload));

    function handlePopState(evt: PopStateEvent) {
      if (evt.state.from === HISTORY_ENTRY_NAME) {
        dispatch(toggleModalAction({ open: false, mode: EListingModalMode.UNSET }));

        window.removeEventListener('popstate', handlePopState);
      }
    }

    if (payload.open && payload.mode === EListingModalMode.FULL_SCREEN) {
      history.replaceState({ from: HISTORY_ENTRY_NAME }, '');
      history.pushState({}, '');
      lastPopStateHandler = handlePopState;

      window.addEventListener('popstate', lastPopStateHandler);
    } else if (!payload.open) {
      window.removeEventListener('popstate', lastPopStateHandler);
    }
  };
